<template>
  <div id="app">
    <!--<div id="nav">-->
      <!--<router-link to="/">Home</router-link> |-->
      <!--<router-link to="/about">About</router-link>-->
    <!--</div>-->
    <router-view/>
  </div>
</template>

<!--xj add 20190814-->
<script>
  import App from './App.js'
  export default {
    ...App,

  }
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  font-size: 16px;
  /*max-width: 600px;*/
  /*min-width: 300px;*/
  margin: 0 auto;
  min-height: 100vh;
}
i{
  font-style: normal;
}
.van-radio__icon .van-icon{
  border-radius: 3px;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
